import { LoginPinFrequencyModel } from "@/Common/Models/Employee/LoginFrequencyModel";
import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { PinFrequencyDocumentType } from "@/Common/Models/UI/Enums";
import { PortalPopupModel } from "@/Portal/Models/PortalPopupModel";
import { ISharedItemProvider } from "@/Portal/Services/ISharedItemProvider";
import { BaseSendMedicalNoteItemToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendMedicalNoteItemToPortalPopupStrategy";
import { SendRequestStrategy } from "./Strategies/SendRequestStrategy";

class LabRequestSharedItemProvider implements ISharedItemProvider {
    public getSharedItemTypeLabel(): string {
        return cacheStore.GetString("ExamRequestLabel");
    }

    public getItemIconClass(): string {
        return "requestIcon";
    }

    public shouldShowFilePreviewInPortfolio(): boolean {
        return true;
    }

    public createSendMedicalNoteItemToPortalPopupStrategy(portalPopupModel: PortalPopupModel, onSignatureAccepted: () => void, onRemoveSignature: () => void): BaseSendMedicalNoteItemToPortalPopupStrategy | null {
        return new SendRequestStrategy(
            PortalLinkedItemType.LabRequest,
            portalPopupModel,
            () => onSignatureAccepted(),
            null,
            () => onRemoveSignature()
        );
    }

    public getPinFrequencyToken(loginPinFrequencyModel: LoginPinFrequencyModel): string {
        return loginPinFrequencyModel?.examRequestToken ?? "";
    }

    public getPinFrequencyDocumentType(): PinFrequencyDocumentType | null {
        return PinFrequencyDocumentType.ExamRequest;
    }
}

export { LabRequestSharedItemProvider };
